// extracted by mini-css-extract-plugin
module.exports = {"container":"OfferingsListClient-module__container--3k_7_"};